import { observer } from "mobx-react-lite";

import { IconArrowDown, IconListWithArrow } from "@synthesis/shared-icons";
import { Button, Tooltip, type DropdownScheme, type StateProps } from "@synthesis/shared-ui";
import { Dropdown } from "@synthesis/shared-ui";

import { SORTS, useStores } from "../../store";
import { type SortType } from "../../store/file-system-store/root-store";

const FILE_SORT_OPTIONS: { id: SortType; label: string; value: SortType }[] = [
  { id: "file.ASC", label: "Имя файла (А-я)", value: "file.ASC" },
  { id: "file.DESC", label: "Имя файла (Я-а)", value: "file.DESC" },
];

const AUTHOR_SORT_OPTIONS: { id: SortType; label: string; value: SortType }[] = [
  { id: "author.ASC", label: "Автор (А-я)", value: "author.ASC" },
  { id: "author.DESC", label: "Автор (Я-а)", value: "author.DESC" },
];

const DATE_SORT_OPTIONS: { id: SortType; label: string; value: SortType }[] = [
  { id: "date.ASC", label: "Дата (сначала старые)", value: "date.ASC" },
  { id: "date.DESC", label: "Дата (сначала новые)", value: "date.DESC" },
];

const SortDropdown = observer(() => {
  const { generalStore } = useStores();

  const sortOptions =
    generalStore.activeTab === "drawings"
      ? [...FILE_SORT_OPTIONS, ...AUTHOR_SORT_OPTIONS, ...DATE_SORT_OPTIONS]
      : generalStore.activeTab === "docs"
        ? [...FILE_SORT_OPTIONS, ...AUTHOR_SORT_OPTIONS]
        : FILE_SORT_OPTIONS;

  const scheme: DropdownScheme = [
    {
      type: "ITEMS",
      elements: sortOptions,
    },
  ];

  const state: StateProps = Object.fromEntries(sortOptions.map((option) => [option.id, () => generalStore.setSortType(option.value)]));

  const activeItemLabels = Object.fromEntries(sortOptions.map((option) => [option.value, option.label]));

  return (
    <Dropdown
      scheme={scheme}
      state={state}
      activeItem={activeItemLabels[generalStore.sortType] ?? SORTS.entities[generalStore.sortType]?.name}
      trigger={
        <Tooltip arrowSide="bottom" description="Сортировка">
          <Button
            data-cy="sortDropdown-button"
            className={generalStore.activeTab !== "drawings" ? "-mr-1.5" : undefined}
            theme="text"
            size="sm"
            leftIcon={<IconListWithArrow className="size-5" />}
            rightIcon={<IconArrowDown className="size-5" />}
          />
        </Tooltip>
      }
    />
  );
});

export default SortDropdown;
